import { Component, OnInit } from "@angular/core";
import { CrudService } from "src/app/services/crud.service";
import { UtilService } from "src/app/services/util.service";
import { LoadingController, AlertController, Platform } from "@ionic/angular";
import { AuthService } from "src/app/services/auth.service";
import { Router } from "@angular/router";

interface Notification {
  titulo: string;
  texto: string;
  perfil: number;
  dataEnvio: string;
}

@Component({
    selector: "app-notifications",
    templateUrl: "./notifications.page.html",
    styleUrls: ["./notifications.page.scss"],
    standalone: false
})
export class NotificationsPage implements OnInit {

  notifications: Notification[] = [];

  constructor(
    private crud: CrudService,
    private util: UtilService,
    private loadCtrl: LoadingController,
    public alertController: AlertController,
    public route: Router,
    private platform: Platform,
    private auth: AuthService
  ) {}

  ngOnInit() {

    this.crud.getData("Notificacao").subscribe((notifications: Notification[]) => {

      this.notifications = notifications;

    });

  }

}
